<template>
    <div class="position-relative p-3">
        <!-- Begin Page Content -->
        <loader v-if="pageLoader"></loader>
        <div class="medical-records upload-dna-section bg-white">
            <div class="row h-100">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="mb-3 d-flex justify-content-end px-3 pt-3">
                           <a href="#" class="d-inline-flex align-items-center whiteButton" @click.prevent="redirection('TestReport')"><span class="plusCircle mb-0 bg-white mr-2"><feather class="mr-1" type="chevron-left"></feather></span> Back</a>
                        </div>
                        <!-- <div class="card-header border-0 bg-white d-flex justify-content-end">
                            <router-link to="/QR-code-screaner" class="btn btn-gray scan-button"><i class="icon icon-mobile-phone"></i>Continue with Mobile</router-link >
                        </div> -->
                        <div class="card-body p-0">
                            <div class="bg-white border-radius-5 p-5">
                                <div class="row no-gutters justify-content-center">
                                    <div class="col-12 col-md-6 text-center upload-reports">
                                        <div class="mt-1">
                                            <!-- <div class="file-upload-preview d-flex justify-content-center border-radius-5 border-0 mb-4 p-3">
                                                <div class="report d-flex">
                                                    <figure class="mb-0"><img src="../../../../static/website/images/reports.svg" alt="" /></figure>
                                                    <a href="#" class="close-icon"><i class="icon icon-close"></i></a>
                                                </div>
                                            </div> -->
                                            <form class="mb-4" action="" method="post" enctype="multipart/form-data" id="UploadDocuments">
                                                <div class="drag-drop">
                                                    <input class="file-upload-field" type="file" name="document" @change="onFileChange($event.target.files[0])" ref="testreport" v-validate="'required'">
                                                    <feather type="upload-cloud"></feather>
                                                    <h3 class="mt-4">Drag and Drop Files Files To Upload</h3>
                                                    <p>you can do this anytime without clicking upload</p>
                                                    <span class="d-block">or</span>
                                                    <button type="submit" class="btn btn-blue attach">Attach File</button>
                                                    <p class="alert alert-danger text-center mt-3" v-if="submitted" v-for="error in errors.collect('document')">{{ error }}</p>
                                                </div>
                                            </form>
                                            <!-- <div class="file-size">
                                                <p>Maximum Upload File Size: 25MB</p>
                                            </div> -->
                                            <div class="preview" v-if="fileName">
                                                <!-- <h4 class="mt-4 mb-3 text-left">Uploading</h4> -->
                                                <div class="file-upload d-flex justify-content-between align-items-center border-radius-5 border-1 bg-white mb-4 p-2">
                                                    <div class="image-upload d-flex align-items-center">
                                                        <figure class="mb-0"><img src="../../../../static/website/images/report.png" alt="" /></figure>
                                                        <h5>{{fileName}}</h5>
                                                    </div>
                                                    <div class="icons d-fle">
                                                        <!-- <a href="#"><i class="icon icon-check-bold"></i></a> -->
                                                        <a href="#" class="close-icon" @click="fileName = '';$refs.testreport.value = ''"><feather type="x"></feather></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group field-wrapper">
                                                <select v-model="select_report_type" class="float-field form-control" name="report type" v-validate="'required'" >
                                                   <option disabled value="">Select Report Type</option>
                                                   <option v-for="(value,key) in  $env_var.uploadDocumentTypeJson" :value="key" v-if="key == 1 || key == 3 || key == 5">
                                                        {{value}}
                                                    </option>
                                                </select>
                                                <p class="error" v-if="submitted" v-for="error in errors.collect('report type')">{{ error }}</p>
                                            </div>
                                            <div class="form-group field-wrapper" v-if="select_report_type == 5">
                                                <div class="position-relative">
                                                    <textarea  placeholder="Other Document..." class="form-control" rows="5" cols="50" v-model="other_doc_type" name="other type" v-validate="'required'"  :class="{ 'is-invalid': submitted && errors.has('other type')}"></textarea>
                                                </div>
                                                <p class="error text-left" v-if="submitted" v-for="error in errors.collect('other type')">{{error}}</p>
                                            </div>
                                            <div class="form-group">
                                                <div class="position-relative">
                                                    <textarea  placeholder="notes" class="form-control" rows="5" cols="50" v-model="notes" name="notes"></textarea><!-- v-validate="'required'"  :class="{ 'is-invalid': submitted && errors.has('notes')}" -->
                                                </div>
                                                <!-- <p class="error text-left" v-if="submitted" v-for="error in errors.collect('notes')">The notes field is required.</p> -->
                                            </div>
                                            <a href="#" class="btn btn-blue" @click.prevent="UploadtestReport()">Upload</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "upload-test-reports",
        data() {
            return {
                pageLoader : false,
                fileName : '',
                select_report_type : '',
                test_type : {
                    'Thyrocare' : 'Thyrocare',
                    'Lal path labs' : 'Lal path labs',
                    'Nueclear' : 'Nueclear',
                    'Srl' : 'Srl',
                    'Healthians':'Healthians',
                    'Gurmeen' :'Gurmeen'
                },
                submitted : false,
                notes: '',
                other_doc_type: '',

            };
        },
         methods:{ 
            onFileChange(event){
                var fileData =  event;
                this.fileName = fileData.name;
                
            },
            UploadtestReport(){
                const _that = this
                let UploadReport = document.getElementById('UploadDocuments');
                let form_name = new FormData(UploadReport);
                let form_data_get = form_name.get('document');
                _that.submitted = true;
                form_name.append("type" , _that.select_report_type);
                form_name.append("notes" , _that.notes);
                form_name.append("doc_type_other" ,  _that.other_doc_type || '');
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json = {
                            'globalParams' : {
                                "form" : form_name,
                            },'localParams' : {'parameter' : _that, 'type' :'form'}
                        }
                        this._runUploadPatientTestReport(input_json)
                    }
                }); 
            },
            reset(){
                this.submitted = false
                this.fileName = ''
                this.select_report_type = ''
                this.$refs.testreport.value = ''
            }   
        },
        created(){
           this.pageName('Upload Your Test')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/test_report/upload-test-reports.vue